import { useNavigate, useSearchParams } from 'react-router-dom'
import { RequireAuth } from '@/components/auth/RequireAuth'
import { ClaimPropertyWizard } from '@/components/claim/ClaimPropertyWizard'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

/**
 * Deep-link / full-page claim flow (e.g. from property profile).
 * The Properties tab uses ClaimPropertyModal instead.
 */
export function ClaimPropertyPage() {
  return (
    <RequireAuth>
      <ClaimPropertyPageContent />
    </RequireAuth>
  )
}

function ClaimPropertyPageContent() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const propertyId = searchParams.get('propertyId')

  return (
    <div className="w-full">
      <Card>
        <CardHeader>
          <CardTitle>Add your property</CardTitle>
        </CardHeader>
        <CardContent>
          <ClaimPropertyWizard
            initialPropertyId={propertyId}
            onCancel={() => navigate(-1)}
            onComplete={() => navigate('/properties', { replace: true })}
          />
        </CardContent>
      </Card>
    </div>
  )
}
